/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterUdfText = {
    filterType: CompositeSearchEnhancedFilterUdfText.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<string>;
};

export namespace CompositeSearchEnhancedFilterUdfText {

    export enum filterType {
        UDF_TEXT1 = 'udfText1',
        UDF_TEXT2 = 'udfText2',
        UDF_TEXT3 = 'udfText3',
        UDF_TEXT4 = 'udfText4',
        UDF_TEXT5 = 'udfText5',
        UDF_TEXT6 = 'udfText6',
        UDF_TEXT7 = 'udfText7',
        UDF_TEXT8 = 'udfText8',
        UDF_TEXT9 = 'udfText9',
        UDF_TEXT10 = 'udfText10',
    }


}

